import { INLINES, BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { useRouter } from 'next/router'

export type TextSectionProps = {
  content: any
  alignCenter: boolean
  sectionId: string
}

type optionsProps = {
  alignCenter: boolean
  router: any
}

const options = ({ alignCenter, router }: optionsProps) => {
  return {
    // Preserve newlines in rich text content by adding <br/> tags.
    renderText: (text) => {
      return text.split('\n').reduce((children, textSegment, index) => {
        return [...children, index > 0 && <br key={index} />, textSegment]
      }, [])
    },
    renderNode: {
      [INLINES.HYPERLINK]: (node: any) => {
        if (
          node.data.uri.includes('youtube.com/embed') ||
          node.data.uri.includes('youtube-nocookie.com/embed')
        ) {
          return (
            <div
              className="flex justify-center"
              data-name="text-section-iframe"
            >
              <iframe
                className="youtube-embed"
                title="Youtube video player"
                width="840"
                height="472"
                src={node.data.uri}
                frameBorder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          )
        } else {
          return (
            <a
              href={node.data.uri}
              target={
                router?.basePath?.includes(node.data.uri) ? '_self' : '_blank'
              }
              rel="noreferrer"
              data-name="text-section-link"
            >
              {node.content[0].value}
            </a>
          )
        }
      },
      [BLOCKS.HEADING_1]: (node: any, children: any) => (
        <h1 className={alignCenter ? 'my-8 text-center' : ''}>{children}</h1>
      ),
      [BLOCKS.HEADING_2]: (node: any, children: any) => (
        <h2 className={alignCenter ? 'my-8 text-center' : ''}>{children}</h2>
      ),
      [BLOCKS.HEADING_3]: (node: any, children: any) => (
        <h3 className={alignCenter ? 'my-8 text-center' : ''}>{children}</h3>
      ),
      [BLOCKS.PARAGRAPH]: (node: any, children: any) => (
        <div className="m-auto lg:max-w-2xl">
          <p className={alignCenter ? 'text-center' : ''}>{children}</p>
        </div>
      ),
    },
  }
}

export default function TextSection({
  content,
  alignCenter,
}: TextSectionProps): JSX.Element {
  const router = useRouter()
  return (
    <div className="global-richtext">
      {documentToReactComponents(
        content.json,
        options({
          alignCenter,
          router,
        })
      )}
    </div>
  )
}
